export default class StreamingProcessor {
    constructor({ update_status_content, update_tip_content }) {
        this.nodeStatuses = new Map();
        this.searchPlan = null;
        this.currentIteration = 0;
        this.update_status_content = update_status_content;
        this.update_tip_content = update_tip_content;
    }
    
    processEvent(eventData) {
        const { event, data } = eventData;
        
        switch (event) {
            case "nextAgentFlow":
                this.handleStatusChange(data);
                break;
                
            case "agentFlowExecutedData":
                this.handleDataUpdate(data);
                break;
                
            default:
                console.warn(`未知事件类型: ${event}`);
        }
    }
    
    handleStatusChange(data) {
        // 更新状态记录
        this.nodeStatuses.set(data.nodeId, {
            label: data.nodeLabel,
            status: data.status
        });
        
        // 更新UI显示
        this.updateProgressBar();
    }
    
    handleDataUpdate(nodesArray) {
        nodesArray.forEach(node => {
            // 更新状态
            this.nodeStatuses.set(node.nodeId, {
                label: node.nodeLabel,
                status: node.status
            });
            
            if (node.status === "FINISHED") {
                this.processFinishedNode(node);
            }
        });
        
        this.updateProgressBar();
    }
    
    processFinishedNode(node) {
        switch (node.nodeLabel) {
            case "Planner":
                if (node.data.state?.search_key_reason) {
                    this.searchPlan = node.data.state.search_key_reason;
                    this.displaySearchPlan();
                }
                break;
                
            case "Search Agent":
                if (node.data.iterationIndex !== undefined) {
                    this.currentIteration = node.data.iterationIndex + 1;
                    this.displayIterationProgress();
                }
                break;
        }
    }
    
    updateProgressBar() {
        const total = this.nodeStatuses.size;
        const finished = Array.from(this.nodeStatuses.values())
            .filter(node => node.status === "FINISHED").length;
        
        const progress = (finished / total) * 100;
        console.log(`整体进度: ${progress.toFixed(1)}%`);
        
        // 显示各节点状态
        this.nodeStatuses.forEach((node, nodeId) => {
            const statusIcon = this.getStatusIcon(node.status);
            console.log(`${statusIcon} ${node.label}: ${node.status}`);
            this.update_status_content(`${statusIcon} ${node.label}: ${node.status}`);
        });
    }
    
    getStatusIcon(status) {
        switch (status) {
            case "PENDING": return "⏳";
            case "INPROGRESS": return "🔄";
            case "FINISHED": return "✅";
            default: return "❓";
        }
    }
    
    displaySearchPlan() {
        let content = '🎯 AI Search Plan:<br>';

        console.log("\n🎯 AI搜索计划:");

        this.searchPlan.forEach((item, index) => {
            console.log(`${index + 1}. ${item.query}`);
            console.log(`   💡 ${item.reason}`);

            content += `${index + 1}. ${item.query}<br>`;
            content += `   💡 ${item.reason}<br>`;
        });

        console.log("");

        this.update_tip_content(content);
    }
    
    displayIterationProgress() {
        console.log(`🔍 执行第 ${this.currentIteration} 轮搜索中...`);
    }
}